<template>
  <button
    type="button"
    class="dashboard-mode-switch"
    :class="[
      `dashboard-mode-switch--${variant}`,
      { 'dashboard-mode-switch--floating': floating },
    ]"
    @click="switchDashboard"
  >
    <img :src="iconSrc" alt="" class="dashboard-mode-switch__icon" />
    <span class="dashboard-mode-switch__label">{{ label }}</span>
  </button>
</template>

<script>
import { getTenantPrefixFromRoute } from "@/utils/tenant";

export default {
  name: "DashboardModeSwitch",
  props: {
    variant: {
      type: String,
      default: "gradient",
      validator: (v) => ["gradient", "solid"].includes(v),
    },
    floating: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isAgentic() {
      return (this.$route.path || "").includes("/agentic-dashboard");
    },
    label() {
      return this.isAgentic
        ? "Switch to conventional Dashboard"
        : "Switch to Agentic AI Dashboards";
    },
    tenantId() {
      return getTenantPrefixFromRoute(this.$route) || "";
    },
    iconSrc() {
      return require("../../../assets/Svg/LeftMenu/dashboard-grid-white.svg");
    },
  },
  methods: {
    switchDashboard() {
      const tenantId = this.tenantId;
      if (!tenantId) return;

      if (this.isAgentic) {
        localStorage.setItem("activeMenu", "Dashboards");
        localStorage.setItem("lastActiveMenu", "Dashboards");
        this.$router.push(`/${tenantId}/Dashboards`);
      } else {
        localStorage.setItem("activeMenu", "Agentic AI Dashboards");
        localStorage.setItem("lastActiveMenu", "Agentic AI Dashboards");
        this.$router.push(`/${tenantId}/agentic-dashboard`);
      }
    },
  },
};
</script>

